import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="kpis" routeLang="en" />;

export const Route = createFileRoute("/en/tools/kpis")({
  head: () => publicToolHead("kpis", "en"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});